// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__179lt","controls":"styles_controls__1cbtW","charLimit":"styles_charLimit__3ZyR6","input":"styles_input__g99ys","send":"styles_send__3Uj-B"};